<div class="modal active coverageAssessment">
  <div class="modal__container modal__container--sm" style="height: fit-content;top: 0%;">
    <div class="fields">
      <h2>Coverage Assessment Options</h2>
      <div class="close" (click)="cancelCoverageAssessmentTool()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  name="ngCoverageAssessmentForm" #ngForm="ngForm" id="coverageAssessmentForm" class="active" style="flex-direction: row;max-height: calc(100vh - 48px) !important;">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>Layer Settings</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">Calculation Name</label>
                  <input name="calculationName" type="text" [(ngModel)]="calculationControlService.coverageAssessmentDTOModal.calculationName" [required]="true"
                  forbiddenSubstring={{forbiddenSubstringName}}  alphaNumeric #calculationName="ngModel"/>
                  <span class="error" *ngIf="calculationName.errors?.forbiddenName">
                    Name cannot contain {{forbiddenSubstringName}}.
                  </span>
                  <span class="error" *ngIf=" (calculationName.dirty || calculationName.touched) && calculationName.errors?.nonAlphaNumeric">
                    Only alphanumeric characters, hyphens and underscores are allowed.
                  </span>
                </div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>Calculation Mode</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div style="justify-content: flex-start;">
                  <input id="singleLevel" name="Single Level" type="checkbox" [checked]="singleLevel" (change)="singleLevelActive()" [disabled]="groundLevel"/>
                  <label for="">Use Single Level</label>
                </div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4 class="w-100">Single Altitude Parameteres (AMSL)</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">Single Level Altitude</label>
                  <div class="coordenates">
                    <input type="text" style="width: 35%;" name="singleLevelAltitudeFeet" [disabled]="!singleLevel || groundLevel" [(ngModel)]="calculationControlService.coverageAssessmentDTOModal.singleAltitude" (ngModelChange)="calculationControlService.coverageAssessmentDTOModal.singleAltitudeMeters=pointsController.convertToMeters($event)"/>
                      <span>[ft]</span>
                    <input type="text" style="width: 35%;" name="singleLevelAltitudeMeters" [disabled]="!singleLevel || groundLevel" [(ngModel)]="calculationControlService.coverageAssessmentDTOModal.singleAltitudeMeters" (ngModelChange)="calculationControlService.coverageAssessmentDTOModal.singleAltitude=pointsController.convertToFeet($event)"/>
                      <span>[m]</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4 class="w-100">Single Altitude Parameteres (AMSL)</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">Max Altitude</label>
                  <div class="coordenates">
                    <input type="text" style="width: 35%;" name="maxAltitudeAltitudeFeet" [disabled]="singleLevel" [disabled]="groundLevel" [(ngModel)]="calculationControlService.coverageAssessmentDTOModal.maxAltitude"/>
                      <span>[ft]</span>
                    <input type="text" style="width: 35%;" name="maxAltitudeAltitudeMeters" [disabled]="singleLevel" [disabled]="groundLevel"  [(ngModel)]="calculationControlService.coverageAssessmentDTOModal.maxAltitudeMeters"/>
                      <span>[m]</span>
                  </div>
                </div>
                <div>
                  <label for="">Min Altitude</label>
                  <div class="coordenates">
                    <input type="text" style="width: 35%;" name="minAltitudeFeet" [disabled]="singleLevel" [disabled]="groundLevel" [(ngModel)]="calculationControlService.coverageAssessmentDTOModal.minAltitude"/>
                      <span>[ft]</span>
                    <input type="text" style="width: 35%;" name="minAltitudeMeters" [disabled]="singleLevel" [disabled]="groundLevel" [(ngModel)]="calculationControlService.coverageAssessmentDTOModal.minAltitudeMeters"/>
                      <span>[m]</span>
                  </div>
                </div>
                <div>
                  <label for="">Altitude Increment</label>
                  <div class="coordenates">
                    <input type="text" style="width: 35%;" name="altitudeIncrementFeet" [disabled]="singleLevel" [disabled]="groundLevel"  [(ngModel)]="calculationControlService.coverageAssessmentDTOModal.altitudeInterval"/>
                      <span>[ft]</span>
                    <input type="text" style="width: 35%;" name="altitudeIncrementMeters" [disabled]="singleLevel" [disabled]="groundLevel"  [(ngModel)]="calculationControlService.coverageAssessmentDTOModal.altitudeIntervalMeters"/>
                      <span>[m]</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>Propagation</h4>
                <span> </span>
              </div>
              <div class="dropdown-fields">
                <div>
                  <label for="">Propagation Type</label>
                  <select #propagation required name="propagationType" (change)="onChangePropagation(propagation.value)" [(ngModel)]="calculationControlService.coverageAssessmentDTOModal.propagationType">
                    <option *ngFor="let option_name; let i = index of this.propagationType" value="{{i}}">{{option_name}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>Range Limitation</h4>
                <span> </span>
              </div>
              <div class="dropdown-fields">
                <div>
                  <label for="">Range Limitation</label>
                  <select #rangeLimitationInput required name="rangeLimitationType" (change)="onRangeLimitation(rangeLimitationInput.value)" [(ngModel)]="calculationControlService.coverageAssessmentDTOModal.rangeLimitation">
                    <option *ngFor="let option_name of this.rangeLimitation" value="{{option_name}}">{{option_name}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>Calculation Type</h4>
                <span> </span>
              </div>
              <div class="dropdown-fields">
                <div>
                  <label for="">Calculation Type</label>
                  <select #calculation required name="calculationType" [disabled]="calculationTypeDisabled" [(ngModel)]="calculationControlService.coverageAssessmentDTOModal.calculationType" (change)="onChangeCalculationType(calculation.value)">
                    <option *ngFor="let option_name of this.calculationType" value="{{option_name}}">{{option_name}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>Coverage Algorithm</h4>
                <span> </span>
              </div>
              <div class="dropdown-fields">
                <div>
                  <label for="">Coverage Algorithm</label>
                  <select required name="coverageAlgorithm" [disabled]="groundLevel || coverageAlgorithmDisabled"  [(ngModel)]="calculationControlService.coverageAssessmentDTOModal.coverageAlgorithm">
                    <option *ngFor="let option_name of this.coverageAlgorithmType" value="{{option_name}}">{{option_name}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>Calculation Options</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div style="justify-content: flex-start;">
                  <input id="altitudeLevel" name="Altitude Level" type="checkbox" [disabled]="singleLevel" [checked]="groundLevel" (change)="groundLevelActive()" [(ngModel)]="calculationControlService.coverageAssessmentDTOModal.useAltitudeAboveGround"/>
                  <label style="width: calc(100% - 40px);" for="">Use Altitude above ground level</label>
                </div>
                <div>
                  <label for="">Altitude above ground</label>
                  <div class="coordenates">
                    <input type="text" style="width: 35%;" name="altitudeAboveGroundFeets" [disabled]="!groundLevel" [(ngModel)]="calculationControlService.coverageAssessmentDTOModal.altitudeAboveGround" (ngModelChange)="calculationControlService.coverageAssessmentDTOModal.altitudeAboveGroundMeters=pointsController.convertToMeters($event)"/>
                      <span>[ft]</span>
                    <input type="text" style="width: 35%;" name="altitudeAboveGroundMeters" [disabled]="!groundLevel" [(ngModel)]="calculationControlService.coverageAssessmentDTOModal.altitudeAboveGroundMeters" (ngModelChange)="calculationControlService.coverageAssessmentDTOModal.altitudeAboveGround=pointsController.convertToFeet($event)"/>
                      <span>[m]</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="fields__btn">
            <button type="submit" [ngClass]="ngForm.form.valid ? 'blue' : 'gray'" [disabled]="!ngForm.form.valid" (click)="calculate()">
              Ok
            </button>
            <button class="gray" (click)="cancelCoverageAssessmentTool()">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
